export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#FAF9F6] border-t border-[#D5D1C8] py-12 md:py-16"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
        <div className="md:col-span-6">
          <img
            src="/brand/verdea-logo.png"
            alt="VERDEA"
            className="h-28 md:h-36 w-auto object-contain -ml-2"
          />
          <p className="overline mt-3">Giardiniere · L'arte del verde · Milano</p>
          <p className="text-sm text-[#5C6B62] mt-3 max-w-sm">
            Progetto di <span className="text-[#1A3628]">Alexander Ciarrocchi</span> —
            cura, potatura e progettazione di spazi verdi a Milano e provincia.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="overline mb-3">Contatti</p>
          <a
            href="mailto:info@verdeagreen.it"
            className="block text-sm text-[#1A3628] link-underline mb-1"
          >
            info@verdeagreen.it
          </a>
          <a
            href="tel:+393347256924"
            className="block text-sm text-[#1A3628] link-underline mb-1"
          >
            334 725 6924
          </a>
          <p className="text-sm text-[#5C6B62]">Milano e provincia</p>
        </div>
        <div className="md:col-span-3 md:text-right">
          <p className="overline mb-3">Servizi</p>
          <p className="text-sm text-[#5C6B62] leading-relaxed">
            Manutenzione · Potatura ·<br /> Progettazione · Irrigazione · Cura piante
          </p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-12 pt-6 border-t border-[#D5D1C8] flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <p className="text-xs text-[#5C6B62]">
          © {year} VERDEA · Alexander Ciarrocchi · P. IVA 12412030962
        </p>
        <p className="text-xs italic font-accent text-[#5C6B62]">
          verdeagreen.it · realizzato con cura, come un giardino.
        </p>
      </div>
    </footer>
  );
}
